import styled from 'styled-components';
import { Label as SharedLabel } from 'components/Label';

export const Label = styled(SharedLabel).attrs(() => ({
  color: 'textSubtle',
}))`
  flex: 1 1 auto;
  width: min(300px, 50%);
`;
